module.exports = __webpack_public_path__ + "static/media/insta-9.58c64d67.png";